import React, {useCallback, useContext, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';
import {getMainColumnHeader} from 'src/utils/getMainColumnHeader';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';
import {LocaleContext} from '@pb/kit-context-locale';


import {COLUMNS, HEADERS} from '../constants';
import {groupsTabStateActions, groupsTabStateSelector} from '../slices/groups-tab-state.slice';
import {groupsTabResultSelector} from '../slices/groups-tab.slice';
import {GroupSortField as GroupSortFields} from '../typedef';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

export const GroupNameHeader = () => {
    const dispatch = useDispatch();

    const cacheKeys = useSelector(groupsTabStateSelector);
    const data = useSelector(groupsTabResultSelector);
    const {locale} = useContext(LocaleContext);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(groupsTabStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: GroupSortFields.GROUP_NAME,
        }));
    }, [dispatch]);

    const caption = useMemo(
        () => getMainColumnHeader(HEADERS[COLUMNS.GROUP_NAME], locale, data?.totalCount),
        [data?.totalCount, locale],
    );

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === GroupSortFields.GROUP_NAME
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={caption}
            onSort={sort}
        />
    );
};
